/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePalReauthCaseManagerRequest
 */
export interface UpdatePalReauthCaseManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthCaseManagerRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthCaseManagerRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthCaseManagerRequest
     */
    fax?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthCaseManagerRequest
     */
    email?: string | null;
}

/**
 * Check if a given object implements the UpdatePalReauthCaseManagerRequest interface.
 */
export function instanceOfUpdatePalReauthCaseManagerRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdatePalReauthCaseManagerRequestFromJSON(json: any): UpdatePalReauthCaseManagerRequest {
    return UpdatePalReauthCaseManagerRequestFromJSONTyped(json, false);
}

export function UpdatePalReauthCaseManagerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthCaseManagerRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'fax': !exists(json, 'fax') ? undefined : json['fax'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function UpdatePalReauthCaseManagerRequestToJSON(value?: UpdatePalReauthCaseManagerRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'phone': value.phone,
        'fax': value.fax,
        'email': value.email,
    };
}

